import React from 'react';
import moment from 'moment';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import vi from '../locales/vi.json';
import en from '../locales/en.json';

// moment.locale('vi');

const LocaleComponent = (props) => {
  const localeIntl = {
    locale: props.locale,
    messages: props.locale === 'en' ? en : vi,
  };
  moment.locale(props.locale || 'vi');
  return <IntlProvider {...localeIntl}>{props.children}</IntlProvider>;
};

export default connect(
  (state) => ({
    locale: state.system.locale,
  }),
  null
)(LocaleComponent);
